import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Checkbox from 'material-ui/Checkbox';
import { ListItem } from 'material-ui/List';
import { SelectableList, Spinner, ControlBar, Control } from 'components';
import * as styles from './CheckboxList.scss';
var CheckboxList = (_dec = connect(function (state) {
  return {
    theme: state.theme
  };
}, {}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(CheckboxList, _Component);

  var _super = _createSuper(CheckboxList);

  function CheckboxList(props) {
    var _this;

    _classCallCheck(this, CheckboxList);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "renderList", function (items) {
      if (items.length === 0) return null;
      var listItems = [];
      var listItemStyle = {
        borderBottom: '1px solid #dfdfdf'
      };
      items.forEach(function (c, index) {
        listItems.push( /*#__PURE__*/React.createElement(ListItem, {
          key: index,
          innerDivStyle: {
            padding: 11
          },
          style: listItemStyle,
          value: index,
          primaryText: /*#__PURE__*/React.createElement("p", {
            className: styles.primaryText,
            style: {
              color: _this.props.theme.colors.secondaryColor
            }
          }, c.name)
        }));
      });
      return /*#__PURE__*/React.createElement(SelectableList, {
        defaultValue: _this.state.selectedIndex,
        style: {
          flex: '1 1 auto',
          padding: 0,
          paddingLeft: 50
        },
        onChange: _this.props.onRowClick
      }, listItems);
    });

    _defineProperty(_assertThisInitialized(_this), "renderCheckboxes", function (items) {
      return /*#__PURE__*/React.createElement("div", {
        className: styles.checkboxList
      }, items.map(function (c, index) {
        return /*#__PURE__*/React.createElement(Checkbox, {
          key: index,
          checked: !!_this.props.checked.find(function (cId) {
            return cId === c.id;
          }),
          onCheck: function onCheck(e, isChecked) {
            return isChecked ? _this.props.onCheck(c.id) : _this.props.onUncheck(c.id);
          },
          iconStyle: {
            marginTop: 13,
            marginLeft: 6
          },
          style: {
            borderBottom: '1px solid #dfdfdf',
            height: 75,
            margin: 0,
            width: '100%'
          }
        });
      }));
    });

    _this.state = {
      selectedIndex: 999
    };
    return _this;
  }

  _createClass(CheckboxList, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, this.renderCheckboxes(this.props.listItems), this.renderList(this.props.listItems));
    }
  }]);

  return CheckboxList;
}(Component), _defineProperty(_class2, "propTypes", {
  listItems: PropTypes.array.required,
  onRowClick: PropTypes.func.isRequired,
  onCheck: PropTypes.func.isRequired,
  onUncheck: PropTypes.func.isRequired,
  checked: PropTypes.array
}), _defineProperty(_class2, "defaultProps", {
  selected: []
}), _temp)) || _class);
export default CheckboxList;